import { Controller } from 'stimulus'
import { haptics } from '~/common/helpers/haptics'

export default class extends Controller {
  static targets = [
    'select',
    'decreaseButton',
    'increaseButton',
    'removeButton',
  ]

  static values = {
    removeSelectValue: String,
  }

  // If the selected option is the last one, the 'increaseButton' button should be disabled
  //   - We also need to ensure we show the decrease button, and hide the remove button if present
  // If the selected option is the first one:
  //   - If the selector can remove the item, we should render the 'removeButton' instead of the 'decreaseButton'
  //   - If the selector cannot remove the item, we should render the 'decreaseButton' disabled
  //   - Also make sure the 'increaseButton' is enabled
  // Whenever the selected option is in the middle, hide the removeButton if present,
  // and enable both 'decreaseButton' and 'increaseButton'
  updateButtons() {
    if (this.selectTarget.selectedIndex == 0) {
      // User just selected the first possible option
      if (this.hasRemoveButtonTarget) {
        this.removeButtonTarget.classList.remove('hidden')
        this.decreaseButtonTarget.classList.add('hidden')
      }

      this.decreaseButtonTarget.classList.add('t-btn-disabled')
      this.increaseButtonTarget.classList.remove('t-btn-disabled')
    } else if (
      this.selectTarget.selectedIndex ==
      this.selectTarget.options.length - 1
    ) {
      // User just selected the last possible option
      if (this.hasRemoveButtonTarget) {
        this.removeButtonTarget.classList.add('hidden')
        this.decreaseButtonTarget.classList.remove('hidden')
      }
      this.decreaseButtonTarget.classList.remove('t-btn-disabled')
      this.increaseButtonTarget.classList.add('t-btn-disabled')
    } else {
      // User just selected a middle option
      if (this.hasRemoveButtonTarget) {
        this.removeButtonTarget.classList.add('hidden')
        this.decreaseButtonTarget.classList.remove('hidden')
      }
      this.decreaseButtonTarget.classList.remove('t-btn-disabled')
      this.increaseButtonTarget.classList.remove('t-btn-disabled')
    }
  }

  increase() {
    if (this.canIncrease()) {
      this.selectTarget.selectedIndex += 1
      this.triggerChange()
      haptics.tick()
    } else {
      haptics.reject()
    }
  }

  decrease() {
    if (this.canDecrease()) {
      this.selectTarget.selectedIndex -= 1
      this.triggerChange()
      haptics.tick()
    } else {
      haptics.reject()
    }
  }

  remove() {
    // If the selected option is already the first (lower) one,
    // and we passed a "removeSelectValue",
    // we create, inject and select the option here
    // so the back-end handles it.
    this.selectTarget.options.add(this.removeOption(), 0)
    this.selectTarget.selectedIndex = 0
    this.triggerChange()
  }

  removeOption() {
    if (this.hasRemoveSelectValue) {
      return new Option(this.removeSelectValue, this.removeSelectValue)
    } else {
      return new Option('0', '0')
    }
  }

  canIncrease() {
    return (
      this.selectTarget.options.length > this.selectTarget.selectedIndex + 1
    )
  }

  canDecrease() {
    return this.selectTarget.selectedIndex > 0
  }

  triggerChange() {
    return this.selectTarget.dispatchEvent(new Event('change'))
  }
}
